// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {combineReducers, type Reducer} from '@reduxjs/toolkit';

export function createReducer<S>(...reducerSets: any[]): Reducer<S> {
    // Merge each dictionary of reducers into a single combined reducer
    return combineReducers<S>(
        reducerSets.reduce((fullSet, reducerSet) => {
            return {...fullSet, ...reducerSet};
        }, {})) as Reducer<S>;
}
